import { FederatedHandlerResponse } from './types';

const errorRegex = new RegExp('error_description=(.*?)&');
export const handleCallbackError = (
  callback: string
): FederatedHandlerResponse => {
  const errorMessage = callback?.match(errorRegex)![1]?.replace(/\+/g, ' ');

  return {
    status: 'error',
    error:
      errorMessage?.split('failed with error')![1] ||
      'Something went wrong. Please try again later',
    user: null,
  };
};
